import * as Yup from 'yup';

const REQUIRED_ERROR = 'Required';

export const validationSchema = Yup.object().shape({
  client_id: Yup.string().required(REQUIRED_ERROR),
  client_secret: Yup.string().required(REQUIRED_ERROR),
  partner_id: Yup.string().required(REQUIRED_ERROR),
});
